import React from 'react'
import { FormattedMessage } from 'react-intl'
import KanBoIcon from 'components/KanBoIcon'
import * as UserActivityConfigTypes from 'const/UserActivityConfigTypes'
import { useHistory } from 'react-router'

const UserMenu = ({
  children,

  id,
  profileKey,
  defaultMenu,
  menu,
  onShowProfile,
  onShowActivities,

  myBoardEnabled,
  userActivityConfig,
  currentUserId,

  showProfile,
  setUserActivitiesId,
}) => {
  const history = useHistory()

  const compMenu = []

  if (defaultMenu) {
    compMenu.push({
      icon: <KanBoIcon fixedWidth name='kanbo-16-user' />,
      title: <FormattedMessage id='USER_SHOW_PROFILE' />,
      onClick: () => {
        showProfile({
          profileKey
        })

        onShowProfile && onShowProfile()
      }
    })

    if (
      userActivityConfig === UserActivityConfigTypes.ALL ||
      (
        userActivityConfig === UserActivityConfigTypes.ONLY_ME &&
        id === currentUserId
      )
    ) {
      compMenu.push({
        icon: <KanBoIcon fixedWidth name='kanbo-16-stream' />,
        title: <FormattedMessage id='ACTIVITY_STREAM_HEADER' />,
        onClick: () => {
          setUserActivitiesId(id)

          onShowActivities && onShowActivities()
        }
      })
    }

    if (myBoardEnabled) {
      compMenu.push({
        icon: <KanBoIcon fixedWidth name='kanbo-16-my-board-2' />,
        title: <FormattedMessage id='MYBOARD' />,
        onClick: () => {
          history.push('/myboard/' + id)
        }
      })
    }
  }

  if (menu) {
    compMenu.push(...menu)
  }

  if (typeof children === 'function') {
    return children({ menu: compMenu })
  } else {
    return null
  }
}

export default UserMenu
